import { Fragment } from 'react';

export function Jurisdiction() {
  return (
    <Fragment>
      The English courts will have exclusive jurisdiction over any claim arising from, or related to, a visit to our site. 
      <br /><br />
      These terms of use and any dispute or claim arising out of or in connection with them or their subject matter or formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with the law of England and Wales.
      <br /><br />
      We make no promise that materials on this Site are appropriate or available for use in locations outside of the United Kingdom, and accessing this site from territories where its contents are illegal or unlawful is prohibited. If you choose to access this site from outside of the United Kingdom, you do so at your own initiative and risk, and are responsible for compliance with applicable laws. You shall comply with all foreign and local laws and regulations which apply to your use of our site in whichever country you are physically located, including without limitation, consumer law and export control laws and regulations.
    </Fragment>
  );
}


export default Jurisdiction;
